<template>
  <tbody>
    <tr
      v-for="siniestro in siniestros.data"
      :key="siniestro"
    >
      <td>
        <span v-if="siniestro.expediente" class="chip-exp">{{ siniestro.expediente }}</span>
        <span v-else class="txt-vacio">Sin nº expediente</span>
      </td>
      <td>
        <div v-if="siniestro.colaborador" class="celda-colaborador">
          <span class="avatar-mini">{{ inicial(siniestro.colaborador) }}</span>
          <span>{{ siniestro?.colaborador?.name == null ? siniestro?.colaborador?.user_name : siniestro?.colaborador?.name }}</span>
        </div>
        <span v-else class="txt-vacio">Colaborador eliminado</span>
      </td>

      <td>
        <div class="celda-clientes">
          <span v-for="(cliente,key) in siniestro.clientes" :key="key" class="chip-cliente">
            {{ cliente.name }}
          </span>
          <span v-if="!siniestro.clientes || !siniestro.clientes.length" class="txt-vacio">—</span>
        </div>
      </td>

      <td>
        <div class="celda-fecha">
          <span>{{ new Date(siniestro?.created_at).toLocaleDateString() }}</span>
          <span class="fecha-hora">{{ new Date(siniestro?.created_at).toLocaleTimeString() }}</span>
        </div>
      </td>

      <td>
        <div class="acciones">
          <ion-badge
            v-if="siniestro.notification.find(not => not.user_id == getUser.id && not.new_notification) "
            color="danger"
            class="badge-aviso"
            title="Nuevas notas no leídas"
          >
            *
          </ion-badge>

          <button class="btn-accion" title="Ver documentos" @click="showDocumentos(siniestro)">
            <ion-icon aria-hidden="true" :icon="folder" :ios="folderOutline" :md="folder"></ion-icon>
          </button>

          <button class="btn-accion" title="Ver notas" @click="showNota(siniestro)">
            <ion-icon aria-hidden="true" :icon="chatbubbles" :ios="chatbubblesOutline" :md="chatbubbles"></ion-icon>
          </button>

          <button
            class="btn-accion"
            title="Ver actuaciones en EPLAN"
            @click="showNotaEplan(siniestro)"
            v-if="getUser?.role?.name == 'Despacho' && siniestro.expediente_id"
          >
            <ion-icon aria-hidden="true" :icon="clipboard" :ios="clipboardOutline" :md="clipboard"></ion-icon>
          </button>

          <button
            class="btn-accion"
            title="Configurar Automatizaciones"
            @click="openModalAutomatizaciones(siniestro)"
            v-if="getUser?.role?.name == 'Despacho'"
          >
            <ion-icon aria-hidden="true" :icon="at" :ios="atOutline" :md="at"></ion-icon>
          </button>

          <button
            class="btn-accion"
            title="Editar siniestro"
            @click="openModalSiniestroEdit(siniestro)"
            v-if="getUser?.role?.name == 'Despacho'"
          >
            <ion-icon aria-hidden="true" :icon="create" :ios="createOutline" :md="create"></ion-icon>
          </button>

          <button
            class="btn-accion"
            :title="siniestro.finalizado ? 'Desarchivar Siniestro' : 'Archivar/Finalizar Siniestro'"
            @click="siniestro.finalizado ? desarchivar(siniestro) : archivar(siniestro)"
            v-if="getUser?.role?.name == 'Despacho'"
          >
            <ion-icon aria-hidden="true" :icon="fileTrayFull" :ios="fileTrayFullOutline" :md="fileTrayFull"></ion-icon>
          </button>

          <button
            class="btn-accion btn-accion-peligro"
            title="Eliminar siniestro"
            @click="eliminarSiniestroConfirmacion(siniestro)"
            v-if="getUser?.role?.name == 'Despacho'"
          >
            <ion-icon aria-hidden="true" :icon="trash" :ios="trashOutline" :md="trash"></ion-icon>
          </button>
        </div>
      </td>
    </tr>
  </tbody>
</template>

<script>
  
  import { 
    defineComponent 
  } from 'vue';
  
  import {
    alertController,
    modalController,
    createAnimation
  } from '@ionic/vue';

  import { 
    arrowUpOutline,
    arrowDownOutline,
    fileTrayFullOutline,
    fileTrayFull,
    downloadOutline,
    download,
    bookmarksOutline,
    bookmarks, 
    eyeOutline, 
    eye, 
    create,
    folderOutline,
    folder,
    chatbubblesOutline,
    chatbubbles,
    clipboardOutline,
    clipboard,
    trashOutline,
    trash,
    createOutline,
    atOutline,
    at
  } from 'ionicons/icons';
  
  import { 
    mapGetters 
  } from "vuex";
  
  import axios from 'axios'
  import toast from '@/plugins/toast'
  import editarSiniestro from '@/views/siniestros/editarSiniestro';
  import modalAutomatizaciones from '@/views/automatizaciones/modalAutomatizaciones';

  export default defineComponent({
  name: 'TableSiniestro',
  props: ['siniestros'],
  setup(){
    return {
      arrowUpOutline,
      arrowDownOutline,
      fileTrayFullOutline,
      fileTrayFull,
      downloadOutline,
      download,
      bookmarksOutline,
      bookmarks, 
      eyeOutline, 
      eye, 
      create,
      folderOutline,
      folder,
      chatbubblesOutline,
      chatbubbles,
      clipboardOutline,
      clipboard,
      trashOutline,
      trash,
      createOutline,
      atOutline,
      at
    }
  },
  computed : {
    ...mapGetters([
        'getUser'
    ]),
  },
  mounted(){
  },
  methods:{
    inicial(colaborador){
      const n = (colaborador?.name || colaborador?.user_name || '?').trim();
      return n ? n[0].toUpperCase() : '?';
    },
    abrirVentana(url){
      const win = window.open(url);
      if (!win) {
        toast.openToast("Tu navegador ha bloqueado la ventana emergente. Permite los pop-ups de este sitio para abrirla.","error",4000);
        return;
      }
      win.focus();
    },
     showNota(siniestro){
      if (!siniestro.chat || !siniestro.chat.id) {
        toast.openToast("Este siniestro todavía no tiene chat de notas.","warning",3000);
        return;
      }
      this.abrirVentana('chat/'+siniestro.chat.id+'?siniestro_id='+siniestro.id);
    },
    showNotaEplan(siniestro){
      if (!siniestro.expediente_id) {
        toast.openToast("Este siniestro no tiene expediente EPLAN asociado.","warning",3000);
        return;
      }
      this.abrirVentana('actuaciones/'+siniestro.expediente_id);
    },
    showDocumentos(siniestro){
      this.abrirVentana('documentos/'+siniestro.id);
    },
    async openModalSiniestroEdit(siniestro) {
      const modal = await modalController
        .create({
          component: editarSiniestro,
          cssClass: 'class-modal-siniestro-edit',
          keyboardClose : true,
          componentProps: {
            data_siniestro: siniestro
          }
        })
      
      modal.present();
      
      modal.onDidDismiss().then((data) => {
        if(data.data == 'reload'){
          this.$emit("reload")
        }
        console.log(data)
      })
    },
    async openModalAutomatizaciones(siniestro) {
      const modal = await modalController
        .create({
          component: modalAutomatizaciones,
          cssClass: 'class-modal-auto',
          keyboardClose : true,
          componentProps: {
            siniestro: siniestro
          }
        })
      
      modal.present();

      modal.onDidDismiss().then((data) => {
        if(data.data == 'reload'){
          this.$emit("reload")
        }
        console.log(data)
      })
    },
    async desarchivar(siniestro){
      const alert = await alertController.create({
        cssClass: 'my-custom-class',
        header: '¡Confirmación!',
        message: '¿Realmente desea desarchivar este siniestro?',
        buttons: [
          {
            text: 'Cancelar',
            role: 'cancel',
            cssClass: 'secondary',
            handler: (blah) => {
              console.log('Confirm Cancel:', blah);
            },
          },
          {
            text: 'Desarchivar',
            handler: async () => {
              var loading = await toast.showLoading()

              await loading.present();
              
              axios.put('/api/siniestros/'+siniestro.id+'/desarchivar')
              .then(() => {
                loading.dismiss()
                toast.openToast("Siniestro desarchivar correctamente","success",2000)
                this.$emit("reload")
               
              })
              .catch(error => {
                loading.dismiss()
                console.log(error)
              })
              },
            },
          ],
        });

      return alert.present();
    },
    async archivar(siniestro){
      const alert = await alertController.create({
        cssClass: 'my-custom-class',
        header: '¡Confirmación!',
        message: '¿Realmente desea archivar este siniestro?',
        buttons: [
          {
            text: 'Cancelar',
            role: 'cancel',
            cssClass: 'secondary',
            handler: (blah) => {
              console.log('Confirm Cancel:', blah);
            },
          },
          {
            text: 'Archivar',
            handler: async () => {
              var loading = await toast.showLoading()

              await loading.present();
              
              axios.put('/api/siniestros/'+siniestro.id+'/archivar')
              .then(() => {
                loading.dismiss()
                toast.openToast("Siniestro archivado correctamente","success",2000)
                this.$emit("reload")
              })
              .catch(error => {
                loading.dismiss()
                console.log(error)
              })
              },
            },
          ],
        });

      return alert.present();
    },
    async eliminarSiniestroConfirmacion(siniestro) {
      const alert = await alertController.create({
        cssClass: 'my-custom-class',
        header: '¡Confirmación!',
        message: '¿Realmente desea eliminar este siniestro?',
        buttons: [
          {
            text: 'Cancelar',
            role: 'cancel',
            cssClass: 'secondary',
            handler: (blah) => {
              console.log('Confirm Cancel:', blah);
            },
          },
          {
            text: 'Eliminar',
            handler: async () => {
              var loading = await toast.showLoading()

              await loading.present();
              
              console.log('Confirm Okay');
              
              axios.delete('/api/siniestros/'+siniestro.id)
              .then(data =>{
                toast.openToast("Siniestro eliminado exitosamente","error",2000)
                loading.dismiss()
                this.$emit("reload")
                console.log(data)
              }).catch(err =>{
                loading.dismiss()
                console.log(err)
              })
            },
          },
        ],
      });
      return alert.present();
    },
    enterAnimation : function () {
      let baseEl = document
        const backdropAnimation = createAnimation()
        .addElement(baseEl.querySelector('ion-backdrop'))
        .fromTo('opacity', '0.01', 'var(--backdrop-opacity)');

      const wrapperAnimation = createAnimation()
        .addElement(baseEl.querySelector('.modal-wrapper'))
        .keyframes([
          { offset: 0, opacity: '0', transform: 'scale(0)' },
          { offset: 1, opacity: '0.99', transform: 'scale(1)' }
        ]);

      return createAnimation()
            .addElement(baseEl)
            .easing('ease-out')
            .duration(500)
            .addAnimation([backdropAnimation, wrapperAnimation]);
    },
    leaveAnimation  : function () {
       return this.enterAnimation(document).direction('reverse');
    },
  }
});
</script>

<style>
.section-divider {
  margin: 20px 0 0 15px;
}

</style>

<style scoped>

ion-label {
  font-weight: bold;
}

ion-input {
  background: rgba(63,81,181,.15);
  border-radius: 20px;
  padding: 5px 8px !important;
  margin: 10px 0;
}

ion-button {
  width: auto;
  --border-radius: 5px;
  height: 35px;
  text-transform: none;
}

.input-text{
  margin-bottom: 15px;
  padding-left: 17px;
  background: #F5F5F5;
  border: 1px solid rgba(183, 183, 183, 0.3);
  box-sizing: border-box;
  border-radius: 24px;
  width :90%;
  height : 48px;
}

/* ---- Celdas rediseñadas ---- */
.chip-exp {
  display: inline-block;
  background: rgba(79, 70, 229, 0.10);
  color: #4338ca;
  font-weight: 700;
  font-size: 13px;
  padding: 4px 10px;
  border-radius: 8px;
}

.txt-vacio {
  color: #94a3b8;
  font-size: 13px;
  font-style: italic;
}

.celda-colaborador {
  display: flex;
  align-items: center;
  gap: 9px;
  color: #334155;
  font-size: 14px;
}

.avatar-mini {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  background: #1e293b;
  color: #fff;
  font-size: 12px;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.celda-clientes {
  display: flex;
  flex-wrap: wrap;
  gap: 5px;
}

.chip-cliente {
  background: #f1f5f9;
  color: #334155;
  font-size: 12px;
  font-weight: 500;
  padding: 3px 9px;
  border-radius: 999px;
  border: 1px solid #e2e8f0;
}

.celda-fecha {
  display: flex;
  flex-direction: column;
  color: #334155;
  font-size: 13px;
}

.fecha-hora {
  color: #94a3b8;
  font-size: 11px;
}

/* ---- Botones de acción compactos ---- */
.acciones {
  display: flex;
  align-items: center;
  gap: 6px;
  justify-content: flex-end;
  flex-wrap: wrap;
}

.btn-accion {
  width: 34px;
  height: 34px;
  border: 1px solid #e2e8f0;
  background: #ffffff;
  color: #475569;
  border-radius: 9px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  font-size: 16px;
  transition: all 0.12s ease;
}

.btn-accion:hover {
  background: #4f46e5;
  border-color: #4f46e5;
  color: #ffffff;
}

/* El icono no captura el ratón: así el tooltip que se muestra es el
   del botón (la descripción) y no el <title> interno del SVG del icono
   (que trae el nombre del icono, p.ej. "folder"). */
.btn-accion ion-icon {
  pointer-events: none;
}

.btn-accion-peligro:hover {
  background: #dc2626;
  border-color: #dc2626;
}

.badge-aviso {
  --background: #dc2626;
  border-radius: 50%;
  width: 8px;
  height: 8px;
  padding: 0;
  overflow: hidden;
  text-indent: -999px;
}

</style>